import React from 'react';
import Button from "@mui/material/Button";

const bonusActions = ["money", "appeal", "reputation", "conservation_point", "x_token", "posturing", "digging", "hunter", "scavenger", "pouch", "perception", "sunbathing"];

const rowStyle = {
    width: '100%',
    backgroundColor: "#2a2d4a",
    borderRadius: "8px",
    display: "flex",
    marginBottom: "8px",
    padding: "10px 15px",
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box',
    minHeight: "8vh"
};

/**
 * Action icons are named by the backend and some of them have no image on disk.
 * Rather than leaving the browser to show its broken image placeholder, the
 * image is swapped for an empty box of the same width once the load fails, so
 * that the rows stay aligned whether or not the icon exists.
 */
const ActionImage = ({src, style}) => {
    const [failed, setFailed] = React.useState(false);
    React.useEffect(() => setFailed(false), [src]);
    if (!src || failed) return <div style={style}/>;
    return <img style={style} src={src} alt={" "} onError={() => setFailed(true)}/>;
};

/**
 * One playable action: its icon, its name, and the button to play it. Shared by
 * every screen that offers a plain list of actions to pick from.
 */
export const ChoiceActionRow = ({action, setConfirmAction}) => {
    return <div style={rowStyle}>
        {
            action.imageName && !bonusActions.some(bonus => action.imageName.toLowerCase().startsWith("bonus_" + bonus)) &&
            <ActionImage style={{width: "5vh", marginRight: "12px"}}
                         src={"/public/arknova/actions/" + action.imageName.toLowerCase() + ".png"}
            />
        }
        {
            bonusActions.map(bonus =>
                action.imageName && action.imageName.toLowerCase().startsWith("bonus_" + bonus) &&
                <div key={action.imageName.toLowerCase()} style={{width: "5vh", marginRight: "12px", position: "relative", height: "6vh",  display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <img style={{width: "100%", height: "auto"}}
                         src={"/public/arknova/actions/bonus_" + (/_\d+$/.test(bonus) ? bonus.replace(/_\d+$/, '') : bonus) + ".png"}
                         alt={" "}
                    />
                    {
                        /_\d+$/.test(bonus) &&
                        <div style={{
                            fontSize: "28px", position: "absolute", top: 0, left: 0,
                            width: "5vh", height: "6vh", textShadow: "-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black",
                            display: "flex", justifyContent: "center", alignItems: "center"
                        }}>
                            {action.imageName.toLowerCase().split("_")[action.imageName.split("_").length - 1]}
                        </div>
                    }
                </div>
            )
        }
        <div style={{flex: 1, fontSize: "16px"}}>
            {action.name}
        </div>
        <div style={{marginLeft: "6px"}}>
            <Button
                variant={"contained"}
                disabled={!action.ok}
                onClick={() => setConfirmAction({action, message: action.name + " ?"})}
                sx={{minWidth: '80px'}}
            >
                Jouer
            </Button>
        </div>
    </div>
};

export default ChoiceActionRow;
